<template>
  <div class="tab-pane fade in active" v-scroll>
    <p v-show="nothing">未搜索到群组</p>
    <p v-show="total">搜索到{{ total }}个群组</p>
    <div class="searchlist" v-for="group in groups" :key="group.group_number">
      <div class="file-icon">
        <img :src="group.group_logo" class="search-avator avator" />
      </div>
      <div class="cont">
        <div class="name">
          <router-link
            :to="{ name: 'group', params: { groupNumber: group.group_number } }"
            target="_blank"
            >{{ group.group_name }}</router-link
          >
          <span class="time">创建时间：{{ group.group_created_date }}</span>
        </div>
        <div class="info">
          群号：{{ group.group_number }} | 群类型：{{
            group.group_category_name
          }}
          | 群主：{{ group.group_owner_name }} | 群成员数：{{
            group.group_memeber_count
          }}
        </div>
      </div>
    </div>
    <div class="scroll-loading" v-show="loading">正在加载中...</div>
    <SearchFilter
      searchType="group"
      @searchByFilter="searchByFilter"
    ></SearchFilter>
  </div>
</template>

<script>
import { getGroups } from "@/api/group/group";
export default {
  name: "Search",
  components: {
    SearchFilter: () => import("./SearchFilter"),
  },
  data() {
    return {
      loading: false,
      nothing: false,
      total: 0,
      query: {
        offset: 0,
        limit: 21, // 每页数量
        category: null,
        searchName: null,
      },
      groups: [],
    };
  },
  created() {
    this.query.searchName = this.$route.query.search;
    this.search();
  },
  beforeRouteUpdate(to, from, next) {
    this.query.searchName = to.query.search;
    this.search();
    next();
  },
  directives: {
    scroll: {
      bind: function (el, binding, vnode) {
        window.addEventListener("scroll", vnode.context.scrollLoad);
      },
      unbind: function (el, binding, vnode) {
        window.removeEventListener("scroll", vnode.context.scrollLoad);
      },
    },
  },
  methods: {
    scrollLoad() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let bodyHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      let hh = scrollTop + window.innerHeight >= bodyHeight - 300;
      if (hh && this.query.offset < this.total - this.query.limit) {
        if (this.loading) {
          return false;
        } else {
          this.query.offset = this.query.offset + this.query.limit;
          this.search();
        }
      }
    },
    searchByFilter(query) {
      this.query.searchName = query.searchName;
      this.query.category = query.category ? query.category : null;
      this.groups = [];
      this.search();
    },
    search() {
      this.nothing = false;
      this.loading = true;
      this.getGroups();
    },
    getGroups() {
      if (!this.query.searchName) {
        this.loading = false;
        this.nothing = true;
        return false;
      }
      getGroups({
        offset: this.query.offset,
        limit: this.query.limit,
        search_name: this.query.searchName,
        category: this.query.category,
        group_review: "adopt",
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            this.total = res.entity.total;
            this.nothing = res.entity.total > 0 ? false : true;
            this.groups = this.groups.concat(res.entity.datas);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
.scroll-loading {
  width: 100%;
  color: #006adf;
  text-align: center;
  line-height: 70px;
  height: 70px;
  /* background: #006adf; */
  float: left;
}
</style>